import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackButtonComponent = _resolveComponent("BackButtonComponent")!

  return (_ctx.haveBrowserHistory)
    ? (_openBlock(), _createBlock(_component_BackButtonComponent, {
        key: 0,
        onGoBack: _ctx.onGoBack
      }, null, 8, ["onGoBack"]))
    : _createCommentVNode("", true)
}